import React from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { Button } from 'rsuite';

interface ButtonExpandAllProps {
  isExpandAll: boolean;
  onExpandAllClick: () => void;
  className?: string;
}

export function ButtonExpandAll(props: ButtonExpandAllProps) {
  const icon: React.ReactNode = props.isExpandAll ? (
    <FaChevronDown aria-hidden />
  ) : (
    <FaChevronRight aria-hidden />
  );

  const collapseExpand = props.isExpandAll ? 'Collapse' : 'Expand';
  const ariaLabel = `${collapseExpand} all accordion panels`;

  return (
    <Button
      aria-label={ariaLabel}
      endIcon={icon}
      onClick={props.onExpandAllClick}
      size="sm"
      className={props.className}
    >
      {`${collapseExpand} all`}
    </Button>
  );
}
